import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Atmosphere from "@/components/atmosphere/Atmosphere";
import Home from "@/pages/Home";
import OurGroup from "@/pages/OurGroup";
import Founder from "@/pages/Founder";
import VisionValues from "@/pages/VisionValues";
import Ventures from "@/pages/Ventures";
import VenturePage from "@/pages/VenturePage";
import Gallery from "@/pages/Gallery";
import Blog from "@/pages/Blog";
import BlogPostDetail from "@/pages/BlogPostDetail";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import { Toaster } from "@/components/ui/sonner";
import SiteScripts from "@/components/SiteScripts";
import AdminApp from "@/admin/AdminApp";

const TOASTER_OPTIONS = { className: "gg-toast" };

const ScrollToTop = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
};

// Legacy-path redirect (keeps old links functional post-restructure).
const LegacyVentureRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/ventures/${slug}`} replace />;
};

// Public marketing site shell (nav/footer/atmosphere/music) -- kept
// entirely separate from the Command Centre admin experience below.
const PublicSite = () => (
  <div className="App min-h-screen relative overflow-x-hidden" style={{ background: "var(--gg-bg-black)" }}>
    <a href="#main-content" className="skip-link">Skip to content</a>
    <SiteScripts />
    <Atmosphere />
    <Navbar />
    <main id="main-content" className="relative z-10 pt-20">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/our-group" element={<OurGroup />} />
        <Route path="/founder" element={<Founder />} />
        <Route path="/vision-values" element={<VisionValues />} />
        <Route path="/ventures" element={<Ventures />} />
        <Route path="/ventures/:slug" element={<VenturePage />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPostDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />

        {/* Legacy route redirects */}
        <Route path="/about" element={<Navigate to="/founder" replace />} />
        <Route path="/mission-vision" element={<Navigate to="/vision-values" replace />} />
        <Route path="/verticals" element={<Navigate to="/ventures" replace />} />
        <Route path="/verticals/:slug" element={<LegacyVentureRedirect />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </main>
    <Footer />
    <Toaster toastOptions={TOASTER_OPTIONS} />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/*" element={<PublicSite />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
